import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import { HiSpeakerphone } from "react-icons/hi";
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { useDispatch, useSelector } from 'react-redux'
import { deleteAnnouncement, resetAnnouncementDeleteState } from 'features/anouncements/announcementSlice'
import { toast } from 'react-toastify'
import DestructiveConfirmModal from 'components/modals/DestructiveConfirmModal'
import { useTranslation } from 'react-i18next'



export default function AncmtItem(props) {
  const { t } = useTranslation('announcements')
  const dispatch = useDispatch()
  const menuRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const { user, admin } = useSelector((state) => state.auth)
  const { profileChurch } = useSelector((state) => state.profileChurch)
  const { isAnnouncementDeletedLoading, isAnnouncementDeletedSuccess, isAnnouncementDeletedError, announcementsDeleteErrorMessage } = useSelector((state) => state.announcement)
  const canManage = Boolean(
    (user?.isOrganization && String(user?._id) === String(profileChurch?._id))
    || admin?.[profileChurch?._id]
  )
  let newDate = new Date(props.data.createdAt)

  useEffect(() => {
    const closeMenu = (event) => {
      if(menuRef.current && !menuRef.current.contains(event.target)) setMenuOpen(false)
    }
    document.addEventListener('mousedown', closeMenu)
    return () => document.removeEventListener('mousedown', closeMenu)
  }, [])

  useEffect(() => {
    if(isAnnouncementDeletedSuccess) setConfirmOpen(false)
  }, [isAnnouncementDeletedSuccess])

  useEffect(() => {
    if(confirmOpen && isAnnouncementDeletedError && announcementsDeleteErrorMessage){
      toast.error(announcementsDeleteErrorMessage)
    }
  }, [announcementsDeleteErrorMessage, confirmOpen, isAnnouncementDeletedError])

  const openDeleteConfirmation = () => {
    dispatch(resetAnnouncementDeleteState())
    setMenuOpen(false)
    setConfirmOpen(true)
  }

  const handleDelete = () => dispatch(deleteAnnouncement({ id: props.data._id }))

  return (
    <AnnouncementCard className="post">
      <div className="postItemTop">

          
          <AnouncementTop>   
            <div style={{display: 'flex', alignItems: 'center',}}>
              <HiSpeakerphone size={20} style={{marginRight: '15px'}}/>
              by {props.data.author.fullName}
              {(props.data.audience?.isTargeted || props.data.audience?.visibility === 'targeted') && <TargetedBadge>Targeted</TargetedBadge>}
            </div>
            <TopRight>
              <TimeAgo datetime={newDate}/>
              {canManage && (
                <MenuWrap ref={menuRef}>
                  <MenuButton type="button" onClick={() => setMenuOpen((value) => !value)} aria-label={t('accessibility.actions')} aria-expanded={menuOpen}>
                    <MoreHorizRoundedIcon />
                  </MenuButton>
                  {menuOpen && (
                    <ActionMenu>
                      <DeleteAction type="button" onClick={openDeleteConfirmation}><DeleteOutlineRoundedIcon /> {t('actions.delete')}</DeleteAction>
                    </ActionMenu>
                  )}
                </MenuWrap>
              )}
            </TopRight>
          </AnouncementTop>


          {/* here we should add an option for the users to hide the announcement for them */}

          {/* <div className="postItemDots" ref={ref1}>
          <div className="postItemDotsDots" onClick={handleDropDown}><MoreHorizIcon/></div>
            {isDropped && (
              <DropDownContainer> 
                {(props.data.creator === user._id || props.data.creator._id || admin[profileChurch._id]) && (
                    <DropDownListItemDiv 
                      disabled={isAnnouncementDeletedLoading}
                      style={{color: 'red'}}
                      onClick={handleDelete}
                      > 
                      <DeleteOutlineIcon className='postItemDotsIcon' /> { isAnnouncementDeletedLoading ? 'Deleting':'Delete'}
                    </DropDownListItemDiv>
                  )}
                </21`
              )}
            </div>*/}
          </div> 

        <PostItemMiddle>
        <PostTextWrap>
          
          {/* break up the text detecting new paragraphs */}
          {props.data.announcementText.split('\n').map((item, i) => {
            return <section key={i}>{item}</section>
          })}

        </PostTextWrap>
      </PostItemMiddle>
      <DestructiveConfirmModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleDelete}
        loading={isAnnouncementDeletedLoading}
        title={t('delete.title')}
        description={t('delete.message')}
        />
    </AnnouncementCard>
  )
}

const AnnouncementCard = styled.div`
  position: relative;
`

const AnouncementTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: var(--lightThemeFontColor);
  width: 100%;
`

const PostItemMiddle = styled.div`
  width: 100%; 
  margin-top: 20px; 
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  
`

const TopRight = styled.div`
  display: flex; align-items: center; gap: 8px; color: #7b878b; font-size: 11px;
`

const MenuWrap = styled.div`
  position: relative;
`

const MenuButton = styled.button`
  width: 32px; height: 32px; display: grid; place-items: center; padding: 0; border: 0;
  border-radius: 9px; background: transparent; color: #697579; cursor: pointer;
  &:hover { background: #eef2f3; color: #344145; }
`

const ActionMenu = styled.div`
  position: absolute; top: calc(100% + 5px); right: 0; z-index: 20; min-width: 190px; padding: 6px;
  border: 1px solid #dfe5e7; border-radius: 11px; background: #fff; box-shadow: 0 12px 30px rgba(20, 37, 42, .16);
`

const DeleteAction = styled.button`
  width: 100%; min-height: 38px; display: flex; align-items: center; gap: 8px; padding: 0 10px;
  border: 0; border-radius: 8px; background: transparent; color: #a53b32; cursor: pointer; font-size: 11px; font-weight: 700;
  svg { font-size: 18px; } &:hover { background: #fff0ee; }
`

const PostTextWrap = styled.div`
  margin-top: 10px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
 
  width: 100%;
  padding: 10px;
  padding-right: 20px;
  color: var(--lightThemeFontColor);

  @media (max-width: 768px) { 
    
  }

  section{
    margin-bottom: 10px;
  }

`

const TargetedBadge = styled.span`
  margin-left: 9px; padding: 4px 7px; border-radius: 7px; background: rgba(0, 180, 204, .11);
  color: var(--themeColor); font-size: 9px; font-weight: 800; letter-spacing: .03em; text-transform: uppercase;
`
